import useMyUser from "src/api/hooks/useMyUser";
import { payloadType } from "src/types/InspectionPayloadType";
import FixedPage from "./Layout/FixedPage";
import { lang } from "src/language/Strings";
import { getLocalizedDeviationTypeFromNumber } from "./ProjectVariationDataCard";
import { ItemDescription } from "src/components/ItemDescription";
import LoadingSpinner from "src/components/LoadingSpinner";
import {
  InspectionResponse,
  SasFileResult,
} from "src/types/InspectionUpdateRequest";
import { InspectionFormMap } from "./InspectionFormMap";
import { MapRef } from "react-map-gl";
import { useState } from "react";

export default function CheckDeviationData({
  deviationPayload,
  setCheckDataOpen,
  saveData,
  onCoordinatesChange,
  setDeviationPayload,
}: {
  deviationPayload: payloadType;
  setCheckDataOpen: (value: boolean) => void;
  saveData: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCoordinatesChange?: (longitude: number, latitude: number) => void;
  setDeviationPayload: React.Dispatch<
    React.SetStateAction<payloadType | null | undefined>
  >;
}) {
  const { data: myUser } = useMyUser();
  const [mapRef, setMapRef] = useState<MapRef | null>(null);
  function onPolygonChange(polygons: [number, number][][]) {
    const geojsonFeature = {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [polygons],
      },
      properties: {
        ...deviationPayload,
      },
    };

    setDeviationPayload((prev) => {
      if (!prev) {
        return prev;
      }
      if (polygons[0][0].length > 0) {
        if (prev?.positionRequest) {
          prev.positionRequest = {
            ...prev.positionRequest,
            latitude: deviationPayload.latitude,
            longitude: deviationPayload.longitude,
            adress: deviationPayload.title || "",
            geometry: JSON.stringify(geojsonFeature.geometry),
          };
        } else {
          prev.positionRequest = {
            geometry: JSON.stringify(geojsonFeature.geometry),
            latitude: deviationPayload.latitude,
            longitude: deviationPayload.longitude,
            adress: deviationPayload.title || "",
          };
        }
        return prev;
      }
      return prev;
    });
  }
  return (
    <FixedPage>
      <div className="w-full max-w-2xl h-[90%] bg-White rounded-lg overflow-hidden">
        <div className="h-full flex flex-col">
          <div className="flex-1 overflow-y-auto p-6">
            <h3 className="text-PrimaryGreen text-center font-semibold text-lg mb-6">
              {lang.confirmSend}
            </h3>
            {deviationPayload?.title && (
              <ItemDescription label={lang.address}>
                {deviationPayload?.title}
              </ItemDescription>
            )}
            {deviationPayload?.information && (
              <ItemDescription label={lang.moment}>
                {deviationPayload?.information}
              </ItemDescription>
            )}
            {deviationPayload?.customer &&
              deviationPayload.customer !== "null" && (
                <ItemDescription label={lang.customer}>
                  {deviationPayload?.customer}
                </ItemDescription>
              )}
            {deviationPayload?.groupId && (
              <ItemDescription label={lang.group}>
                {
                  myUser?.groups?.find((g) => g.id === deviationPayload.groupId)
                    ?.name
                }
              </ItemDescription>
            )}
            {deviationPayload?.deviationType && (
              <ItemDescription label={lang.deviationType}>
                {getLocalizedDeviationTypeFromNumber(
                  Number(deviationPayload?.deviationType)
                )}
              </ItemDescription>
            )}
            {deviationPayload?.description && (
              <ItemDescription label={lang.description}>
                {deviationPayload?.description}
              </ItemDescription>
            )}
            {deviationPayload?.files && deviationPayload.files.length > 0 && (
              <div className="w-full">
                <h4 className="text-PrimaryGreen font-medium text-base mb-3">
                  {lang.attachedFiles}
                </h4>
                <div className="w-full h-96 flex flex-row overflow-x-auto gap-3 p-2 pb-4">
                  {Array.from(deviationPayload.files as SasFileResult[]).map(
                    (image, index) => (
                      <div
                        key={`${image.fileName}-${index}`}
                        className="flex-shrink-0 flex-col h-76 w-52 rounded-lg overflow-hidden bg-White"
                      >
                        <img
                          src={URL.createObjectURL(image.file as File)}
                          alt={`${image.fileName}`}
                          className="w-full h-52 object-contain"
                        />
                        <div className="p-2 space-y-1">
                          <p className="text-sm text-center text-PrimaryGreen font-medium truncate">
                            {image.fileName}
                          </p>
                          {image.depiction && (
                            <p className="text-xs text-center text-PrimaryGreen bg-PrimaryGreen/10 px-2 py-1 rounded">
                              {image.depiction}
                            </p>
                          )}
                          {image.comment && (
                            <p className="text-xs text-center text-PrimaryGreen w-full line-clamp-3">
                              {image.comment}
                            </p>
                          )}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
            <InspectionFormMap
              setMapRef={setMapRef}
              item={deviationPayload as unknown as InspectionResponse}
              onCoordinatesChange={onCoordinatesChange}
              onPolygonChange={onPolygonChange}
            />
            {!mapRef && (
              <img
                src={`https://maps.googleapis.com/maps/api/staticmap?center=${[
                  deviationPayload?.latitude,
                  deviationPayload?.longitude,
                ].join(
                  ","
                )}&zoom=19&size=600x320&maptype=hybrid&markers=color:blue|label:M|${[
                  deviationPayload?.latitude,
                  deviationPayload?.longitude,
                ].join(",")}&key=AIzaSyBu0r8wkFWbfjKeUG3k-MayBWPpHCW5Anc`}
                className="w-full h-40 object-cover rounded-lg mt-4"
              />
            )}
          </div>

          <div className="w-full flex justify-around p-4 border-t">
            <button
              type="button"
              id="cancel-confirmation"
              className="p-2 pl-4 pr-4 bg-[#1F4652] text-White rounded-lg"
              onClick={() => setCheckDataOpen(false)}
            >
              {lang.cancel}
            </button>
            <button
              type="button"
              id="saveItems"
              className="p-2 pl-4 pr-4 bg-[#1F4652] text-White rounded-lg disabled:opacity-50 disabled:bg-[#1F4652]/50"
              onClick={saveData}
            >
              {lang.save}
            </button>
          </div>
        </div>
      </div>
      {<LoadingSpinner />}
    </FixedPage>
  );
}
